import ImageService from "@/services/image/image.service";
import ThumbnailService from "@/services/image/thumbnail.service";

const imageServiceInit = (commit, state) => {
    ImageService.onChange(index => {
        commit("setCurrentIndex", index);
        commit("setThumbs",
            ThumbnailService.getAround(state.galleryFiles, index));
    });
    ImageService.onClose(() => {
        commit("setOpened", false);
    });
    commit("setInitialized", true);
};

export const image = {
    namespaced: true,
    state: () => ({
        opened: false,
        currentIndex: 0,
        galleryFiles: [],
        thumbs: [],
        initialized: false
    }),
    mutations: {
        setOpened(state, value) {
            state.opened = value;
        },
        setGalleryFiles(state, files) {
            state.galleryFiles = files;
        },
        setThumbs(state, files) {
            state.thumbs = files;
        },
        setCurrentIndex(state, index) {
            state.currentIndex = index;
        },
        setInitialized(state, value) {
            state.initialized = value;
        }
    },
    actions: {
        async openGallery({ state, commit }, payload) {
            if (!state.initialized) {
                imageServiceInit(commit, state);
            }
            const result = await ImageService.openGallery(payload);

            commit("setGalleryFiles", result.items);
            commit("setCurrentIndex", result.index);
            commit("setThumbs",
                ThumbnailService.getAround(result.items, result.index)
            );
            commit("setOpened", true);
        },
        closeGallery({ commit }) {
            ImageService.closeGallery();
            commit("setOpened", false);
        }
    }
};